import React from "react";
import { ArrowRight, DoorOpen, Fence, Tractor, Truck, Warehouse, Wrench, BoxIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { services, Service } from "../data/site";
const iconMap: Record<Service['icon'], BoxIcon> = {
  truck: Truck,
  tractor: Tractor,
  fence: Fence,
  warehouse: Warehouse,
  gate: DoorOpen,
  wrench: Wrench
};
export function Services() {
  return <section id="services" className="bg-white py-20 lg:py-28" data-id="element-209" data-mp="13w4m5j3a33a8">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-210" data-mp="z54rkkhmsxaw">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-211" data-mp="z3ld8zfjcwbr">
          <SectionHeading eyebrow="What We Do" tone="light" title={<>
                Every kind of
                <br data-id="element-213" data-mp="q6183fejyfvv" />
                steel work
              </>} description="Fence, entryways, gates, and carports are our bread and butter — but the rig is set up for any welding or fabrication job a ranch, farm, contractor, or homeowner throws at it." data-id="element-212" data-mp="u6uxkd7n82qv" />
          <a href="#contact" className="group inline-flex shrink-0 items-center gap-3 border-2 border-steel-950 px-7 py-4 font-display text-sm font-semibold uppercase tracking-[0.16em] text-steel-950 transition-colors hover:border-brand hover:bg-brand hover:text-white" data-id="element-214" data-mp="36cptlqhbe764">
            Ask About Your Job
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-215" data-mp="32acqzaxv6pdk" />
          </a>
        </div>

        <div className="mt-14 grid gap-px border border-steel-200 bg-steel-200 sm:grid-cols-2 lg:grid-cols-3" data-id="element-216" data-mp="3q0ypaai2gvad">
          {services.map(service => {
          const Icon = iconMap[service.icon];
          return <article key={service.number} className="group relative flex flex-col bg-white p-8 transition-colors hover:bg-steel-950 lg:p-10" data-id="element-217" data-mp="3g1r97fjy6mjk">
                <div className="flex items-start justify-between" data-id="element-218" data-mp="24ndscunm37d1">
                  <span className="flex h-12 w-12 items-center justify-center bg-steel-950 transition-colors group-hover:bg-brand" data-id="element-219" data-mp="24p70kedvhzn5">
                    <Icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-220" data-mp="1pjuhl9nv90ez" />
                  </span>
                  <span className="font-mono text-xs tracking-[0.2em] text-steel-300 group-hover:text-steel-500" data-id="element-221" data-mp="1lir06iq66wbn">
                    {service.number}
                  </span>
                </div>

                <h3 className="mt-8 font-display text-2xl font-bold uppercase tracking-tight text-steel-950 group-hover:text-white" data-id="element-222" data-mp="1bsxpdjxuql8g">
                  {service.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-steel-500 group-hover:text-steel-300" data-id="element-223" data-mp="11ui0lnmaro24">
                  {service.description}
                </p>

                <ul className="mt-6 space-y-2 border-t border-steel-200 pt-5 group-hover:border-white/15" data-id="element-224" data-mp="xt6g1wia5t0s">
                  {service.points.map(point => <li key={point} className="flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.14em] text-steel-500 group-hover:text-steel-200" data-id="element-225" data-mp="2s6nwz0o6jrmu">
                      <span className="h-1.5 w-1.5 bg-brand" aria-hidden="true" data-id="element-226" data-mp="2n5rtupbnk9ih" />
                      {point}
                    </li>)}
                </ul>
              </article>;
        })}
        </div>

        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-steel-300" data-id="element-227" data-mp="2zodtlda8nxev">
          Placeholder service list — final wording to be confirmed
        </p>
      </div>
    </section>;
}